import { checkVisibility } from "../../services/ApiResponseMiddleware";

export enum CoApplicantEnum {
  ADD_COAPPLICANT_BUTTON = "Add Co-Applicant",
  CO_APPLICANT_DETAILS = "CoApplicant Details",
  EDIT_COAPPLICANT_BUTTON = "editCoApplicant",
  DELETE_COAPPLICANT_BUTTON = "deleteCoApplicant",
  RUN_BUREAU_CHECK_BUTTON = "runBureauCheck",
  RESUME_COAPPLICANT_JOURNEY_BUTTON = "resumeCoApplicantJourney",
}

export function getCoApplicantsDetail(coApplicantResponse: any) {
  const coApplicantDetail =
    coApplicantResponse?.dynamicSections[CoApplicantEnum.CO_APPLICANT_DETAILS];

  return {
    ...coApplicantResponse,
    coApplicantDetail,
    coApplicants: coApplicantDetail?.fieldList,
    coApplicantTitle: coApplicantDetail?.label,
    isCardVisible: checkVisibility(coApplicantDetail),
  };
}

export enum CoApplicantInfoId {
  PAN = "pan",
  NAME = "name",
  BUSINESS_NAME = "businessName",
  BUSINESS_PAN = "businessPan",
  CURRENT_ADDRESS = "currentAddress",
  CIF_NUMBER_INDIVIDUAL = "cifNumberIndividual",
  PINCODE = "pincode",
  MOBILE = "mobile",
  RELATIONSHIP_TYPE = "relationshipType",
  CREATED_BY = "createdBy",
}
